export default __webpack_public_path__ + "static/assets/med_pill_elipse_flat_L1_solid_x_01_f_mask.6c23e0c6.png";